module.exports = {
    formatDateTime(time) {
        if (!time) return '';
        let d = new Date(time);
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        let curr_year = d.getFullYear();
        let curr_hours = d.getHours();
        let curr_minus = d.getMinutes();
        let curr_second = d.getSeconds();
        curr_second = curr_second < 10 ? '0' + curr_second : curr_second;
        curr_minus = curr_minus < 10 ? '0' + curr_minus : curr_minus;
        curr_hours = curr_hours < 10 ? '0' + curr_hours : curr_hours;
        curr_date = curr_date < 10 ? '0' + curr_date : curr_date;
        curr_month = curr_month < 10 ? '0' + curr_month : curr_month;

        return (
            curr_hours +
            ':' +
            curr_minus +
            ':' +
            curr_second +
            ' ' +
            curr_date +
            '/' +
            curr_month +
            '/' +
            curr_year
        );
    },
    calculateCampaign(
        subtotal,
        copay_value = 0,
        copay_unit = "$",
        cappay_value = 0,
        cappay_unit = "$"
    ){
        console.log("==================calculateCampaign=========", subtotal,
        copay_value ,
        copay_unit ,
        cappay_value,
        cappay_unit )
        let total = 0;
        let discount = 0;
        let actualCopay = 0;
        copay_value =
            copay_unit === '$'
                ? copay_value
                : (copay_value * subtotal)/100;
        cappay_value =
            cappay_unit === '$'
                ? cappay_value
                : (cappay_value * subtotal)/100;
        if (copay_value === 0) {
            if (cappay_value === 0 || cappay_value > subtotal) {
                discount = subtotal;
                total = 0;
            } else {
                discount = cappay_value;
                total = subtotal - cappay_value ;
            }
        } else {
            if (cappay_value === 0) {
                if (copay_value > subtotal) {
                    actualCopay = subtotal ;
                    discount = subtotal;
                    total = subtotal;
                } else {
                    actualCopay = copay_value ;
                    discount = subtotal;
                    total = copay_value;
                }
            } else {
                if (subtotal > copay_value) {
                    discount = Math.min(subtotal -copay_value, cappay_value);
                    total = subtotal - discount
                    actualCopay = copay_value
                }else{
                    actualCopay = subtotal ;
                    discount = 0 ;
                    total = subtotal
                }
            }
        }
        return {
            total,
            discount,
            actualCopay,
            copay_value,
            cappay_value
        };
    },
    getTimeTimeZone: (date) => {
        let d = new Date(date);
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        let curr_year = d.getFullYear();

        curr_date = curr_date < 10 ? '0' + curr_date : curr_date;
        curr_month = curr_month < 10 ? '0' + curr_month : curr_month;
        return `${curr_date}/${curr_month}/${curr_year}`;
    },
};
